// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendSecureMessagePopup-module__font-s-10____L4Kv {
  font-size: 10px !important;
}

.SendSecureMessagePopup-module__font-s-12___QYcKy {
  font-size: 12px !important;
}

.SendSecureMessagePopup-module__font-s-13___do0SQ {
  font-size: 13px !important;
}

.SendSecureMessagePopup-module__font-s-14___w4prp {
  font-size: 14px !important;
}

.SendSecureMessagePopup-module__font-s-15___kK5kU {
  font-size: 15px !important;
}

.SendSecureMessagePopup-module__font-s-16___dJW4_ {
  font-size: 16px !important;
}

.SendSecureMessagePopup-module__font-s-18___toJZx {
  font-size: 18px !important;
}

.SendSecureMessagePopup-module__font-s-20___xxuBC {
  font-size: 20px !important;
}

.SendSecureMessagePopup-module__font-s-22___B8hzP {
  font-size: 22px !important;
}

.SendSecureMessagePopup-module__font-s-28___FDuOt {
  font-size: 28px !important;
}

.SendSecureMessagePopup-module__font-w-400___sU8cG {
  font-weight: 400 !important;
}

.SendSecureMessagePopup-module__font-w-500___QxemI {
  font-weight: 500 !important;
}

.SendSecureMessagePopup-module__font-w-600___LGX5l {
  font-weight: 600 !important;
}

.SendSecureMessagePopup-module__font-w-700___YqZsM {
  font-weight: 700 !important;
}

.SendSecureMessagePopup-module__p-5___XdIN5 {
  padding: 5px !important;
}

.SendSecureMessagePopup-module__p-12___r9SX_ {
  padding: 12px !important;
}

.SendSecureMessagePopup-module__p-16___TnPF0 {
  padding: 16px !important;
}

.SendSecureMessagePopup-module__p-30___i2mbb {
  padding: 30px !important;
}

.SendSecureMessagePopup-module__p-b-0___mPkMR {
  padding-bottom: 0 !important;
}

.SendSecureMessagePopup-module__p-b-5___rk2Cd {
  padding-bottom: 5px !important;
}

.SendSecureMessagePopup-module__p-b-10___Umrvp {
  padding-bottom: 10px !important;
}

.SendSecureMessagePopup-module__p-b-12___HNQ4_ {
  padding-bottom: 12px !important;
}

.SendSecureMessagePopup-module__p-b-16___YnEcT {
  padding-bottom: 16px !important;
}

.SendSecureMessagePopup-module__p-b-18___TgV4c {
  padding-bottom: 18px !important;
}

.SendSecureMessagePopup-module__p-b-20___pyxV9 {
  padding-bottom: 20px !important;
}

.SendSecureMessagePopup-module__p-b-25___Q3Yfc {
  padding-bottom: 25px !important;
}

.SendSecureMessagePopup-module__p-b-30___PQX7F {
  padding-bottom: 30px !important;
}

.SendSecureMessagePopup-module__p-b-50___dnNNc {
  padding-bottom: 50px !important;
}

.SendSecureMessagePopup-module__p-t-0___oyfh1 {
  padding-top: 0 !important;
}

.SendSecureMessagePopup-module__p-t-12___tcOkr {
  padding-top: 12px !important;
}

.SendSecureMessagePopup-module__p-t-16___pjFbY {
  padding-top: 16px !important;
}

.SendSecureMessagePopup-module__p-t-18___JwPML {
  padding-top: 18px !important;
}

.SendSecureMessagePopup-module__p-t-20___yIDd0 {
  padding-top: 20px !important;
}

.SendSecureMessagePopup-module__p-t-30___WH6q4 {
  padding-top: 30px !important;
}

.SendSecureMessagePopup-module__p-t-40___zKEWu {
  padding-top: 40px !important;
}

.SendSecureMessagePopup-module__p-t-50___KHGUC {
  padding-top: 50px !important;
}

.SendSecureMessagePopup-module__p-l-20___kEbh5 {
  padding-left: 20px !important;
}

.SendSecureMessagePopup-module__p-l-30___o2TMj {
  padding-left: 30px !important;
}

.SendSecureMessagePopup-module__p-l-40___lo5SA {
  padding-left: 40px !important;
}

.SendSecureMessagePopup-module__p-r-16___r9g22 {
  padding-right: 16px !important;
}

.SendSecureMessagePopup-module__p-r-20___uXHiM {
  padding-right: 20px !important;
}

.SendSecureMessagePopup-module__p-r-30___RcHX8 {
  padding-right: 30px !important;
}

.SendSecureMessagePopup-module__p-r-50___fqnN2 {
  padding-right: 50px !important;
}

.SendSecureMessagePopup-module__p-r-60___JOlve {
  padding-right: 60px !important;
}

.SendSecureMessagePopup-module__m-b-1___uWY7Z {
  margin-bottom: 1px !important;
}

.SendSecureMessagePopup-module__m-b-2___gh9QS {
  margin-bottom: 2px !important;
}

.SendSecureMessagePopup-module__m-b-6___oGQW9 {
  margin-bottom: 6px !important;
}

.SendSecureMessagePopup-module__m-b-8___BvuOk {
  margin-bottom: 8px !important;
}

.SendSecureMessagePopup-module__m-b-10___RBdKc {
  margin-bottom: 10px !important;
}

.SendSecureMessagePopup-module__m-b-14___o0jWa {
  margin-bottom: 14px !important;
}

.SendSecureMessagePopup-module__m-b-16___D8vPP {
  margin-bottom: 16px !important;
}

.SendSecureMessagePopup-module__m-b-20___zNQa8 {
  margin-bottom: 20px !important;
}

.SendSecureMessagePopup-module__m-b-22___gzwnb {
  margin-bottom: 22px !important;
}

.SendSecureMessagePopup-module__m-b-24___cqBWw {
  margin-bottom: 24px !important;
}

.SendSecureMessagePopup-module__m-b-30___T2lT_ {
  margin-bottom: 30px !important;
}

.SendSecureMessagePopup-module__m-b-32___rv_o5 {
  margin-bottom: 32px !important;
}

.SendSecureMessagePopup-module__m-b-40___HI0Kh {
  margin-bottom: 40px !important;
}

.SendSecureMessagePopup-module__m-t-2___Dxy7M {
  margin-top: 2px !important;
}

.SendSecureMessagePopup-module__m-t-3___UGR38 {
  margin-top: 3px !important;
}

.SendSecureMessagePopup-module__m-t-4___y_Jzk {
  margin-top: 4px !important;
}

.SendSecureMessagePopup-module__m-t-5___nJGCw {
  margin-top: 5px !important;
}

.SendSecureMessagePopup-module__m-t-8___TdShV {
  margin-top: 8px !important;
}

.SendSecureMessagePopup-module__m-t-10___MJJHr {
  margin-top: 10px !important;
}

.SendSecureMessagePopup-module__m-t-15___UbQwK {
  margin-top: 15px !important;
}

.SendSecureMessagePopup-module__m-t-16___pmzBd {
  margin-top: 16px !important;
}

.SendSecureMessagePopup-module__m-t-20___zTEBC {
  margin-top: 20px !important;
}

.SendSecureMessagePopup-module__m-t-22___NLZMi {
  margin-top: 22px !important;
}

.SendSecureMessagePopup-module__m-t-30___XQsW_ {
  margin-top: 30px !important;
}

.SendSecureMessagePopup-module__m-t-32___Lu9LS {
  margin-top: 32px !important;
}

.SendSecureMessagePopup-module__m-l-auto___b2rYv {
  margin-left: auto !important;
}

.SendSecureMessagePopup-module__m-l-4___KDKgv {
  margin-left: 4px !important;
}

.SendSecureMessagePopup-module__m-l-5___jAD3k {
  margin-left: 5px !important;
}

.SendSecureMessagePopup-module__m-l-6___v0z0W {
  margin-left: 6px !important;
}

.SendSecureMessagePopup-module__m-l-8___cW_DP {
  margin-left: 8px !important;
}

.SendSecureMessagePopup-module__m-l-10___vfSob {
  margin-left: 10px !important;
}

.SendSecureMessagePopup-module__m-l-16___Ud5wA {
  margin-left: 16px !important;
}

.SendSecureMessagePopup-module__m-l-20___xeQ8B {
  margin-left: 20px !important;
}

.SendSecureMessagePopup-module__m-l-24___pqlZQ {
  margin-left: 24px !important;
}

.SendSecureMessagePopup-module__m-l-30___b7Z7h {
  margin-left: 30px !important;
}

.SendSecureMessagePopup-module__m-l-35___a2tUw {
  margin-left: 35px !important;
}

.SendSecureMessagePopup-module__m-l-40___TrZU2 {
  margin-left: 40px !important;
}

.SendSecureMessagePopup-module__m-r-8___PYUeb {
  margin-right: 8px !important;
}

.SendSecureMessagePopup-module__m-r-10___Ff38Z {
  margin-right: 10px !important;
}

.SendSecureMessagePopup-module__m-r-16___fF6PU {
  margin-right: 16px !important;
}

.SendSecureMessagePopup-module__m-r-20___bJ1K9 {
  margin-right: 20px !important;
}

.SendSecureMessagePopup-module__m-r-24___SLh91 {
  margin-right: 24px !important;
}

.SendSecureMessagePopup-module__m-r-30___ZZLf2 {
  margin-right: 30px !important;
}

.SendSecureMessagePopup-module__m-r-40___dy3ZF {
  margin-right: 40px !important;
}

.SendSecureMessagePopup-module__border-r-3___nMKfh {
  border-radius: 3px !important;
}

.SendSecureMessagePopup-module__border-r-4___JaGAV {
  border-radius: 4px !important;
}

.SendSecureMessagePopup-module__border-r-6___yfB8f {
  border-radius: 6px !important;
}

.SendSecureMessagePopup-module__border-r-10___GqJLm {
  border-radius: 10px !important;
}

.SendSecureMessagePopup-module__border-r-12___UaUfw {
  border-radius: 12px !important;
}

.SendSecureMessagePopup-module__border-r-16___uHmfB {
  border-radius: 16px !important;
}

.SendSecureMessagePopup-module__border-r-50___SVqUX {
  border-radius: 50% !important;
}

.SendSecureMessagePopup-module__primary-border___cdTeX {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSecureMessagePopup-module__primary-border-b___L9tqo {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSecureMessagePopup-module__primary-border-t___wJkNX {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSecureMessagePopup-module__primary-border-l___Yx2Nj {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSecureMessagePopup-module__primary-border-r___jNoio {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SendSecureMessagePopup-module__secondary-border___JWQU_ {
  border: 1px solid #637768;
}

.SendSecureMessagePopup-module__secondary-border-b___ntyM2 {
  border-bottom: 1px solid #637768;
}

.SendSecureMessagePopup-module__secondary-border-t___wPM77 {
  border-top: 1px solid #637768;
}

.SendSecureMessagePopup-module__secondary-border-l___grW8w {
  border-left: 1px solid #637768;
}

.SendSecureMessagePopup-module__secondary-border-r___fraiN {
  border-right: 1px solid #637768;
}

.SendSecureMessagePopup-module__gap-0___Gp5Jr {
  gap: 0 !important;
}

.SendSecureMessagePopup-module__gap-2____ydAA {
  gap: 2px !important;
}

.SendSecureMessagePopup-module__gap-4___uvuwv {
  gap: 4px !important;
}

.SendSecureMessagePopup-module__gap-5___o3EBy {
  gap: 5px !important;
}

.SendSecureMessagePopup-module__gap-6___Q68dT {
  gap: 6px !important;
}

.SendSecureMessagePopup-module__gap-8___L7wQ9 {
  gap: 8px !important;
}

.SendSecureMessagePopup-module__gap-10___MvDSD {
  gap: 10px !important;
}

.SendSecureMessagePopup-module__gap-12___eRmSs {
  gap: 12px !important;
}

.SendSecureMessagePopup-module__gap-14___q5Icb {
  gap: 14px !important;
}

.SendSecureMessagePopup-module__gap-16___xAn0z {
  gap: 16px !important;
}

.SendSecureMessagePopup-module__gap-18___sawpB {
  gap: 18px !important;
}

.SendSecureMessagePopup-module__gap-20___K4gWu {
  gap: 20px !important;
}

.SendSecureMessagePopup-module__gap-24___yoXME {
  gap: 24px !important;
}

.SendSecureMessagePopup-module__gap-26___nS1Oj {
  gap: 26px !important;
}

.SendSecureMessagePopup-module__gap-30___MlbHS {
  gap: 30px !important;
}

.SendSecureMessagePopup-module__gap-32___pIZTc {
  gap: 32px !important;
}

.SendSecureMessagePopup-module__gap-40___jljaF {
  gap: 40px !important;
}

.SendSecureMessagePopup-module__gap-50___dlhrY {
  gap: 50px !important;
}

.SendSecureMessagePopup-module__flex-1___AM4DS {
  flex: 1;
}

.SendSecureMessagePopup-module__flex-none___DWjSR {
  flex: none !important;
}

.SendSecureMessagePopup-module__flex-column____weC6 {
  display: flex;
  flex-direction: column !important;
}

.SendSecureMessagePopup-module__flex-row___NDtIq {
  display: flex;
  flex-direction: row !important;
}

.SendSecureMessagePopup-module__vertically-centered___SPLg8 {
  display: flex;
  align-items: center !important;
}

.SendSecureMessagePopup-module__horizontally-centered___i2DHo {
  display: flex;
  justify-content: center !important;
}

.SendSecureMessagePopup-module__horizontally-end___aPuFT {
  display: flex;
  justify-content: end !important;
}

.SendSecureMessagePopup-module__vertically-start___lyz68 {
  display: flex;
  align-items: start !important;
}

.SendSecureMessagePopup-module__space-between___LBpN_ {
  display: flex;
  justify-content: space-between !important;
}

.SendSecureMessagePopup-module__flex-wrap___UOjvb {
  flex-wrap: wrap !important;
}

.SendSecureMessagePopup-module__height-100___UxEIU {
  height: 100%;
}

.SendSecureMessagePopup-module__width-50___YaYll {
  width: 50% !important;
}

.SendSecureMessagePopup-module__width-100___rJmiH {
  width: 100%;
}

.SendSecureMessagePopup-module__cursor-pointer___LvYpx {
  cursor: pointer;
}

.SendSecureMessagePopup-module__cursor-not-allowed___ywYPs {
  cursor: not-allowed !important;
}

.SendSecureMessagePopup-module__absolute-centered___UPGtt {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SendSecureMessagePopup-module__absolute___ZYUel {
  position: absolute;
}

.SendSecureMessagePopup-module__relative___qODTs {
  position: relative;
}

.SendSecureMessagePopup-module__fixed___hC6cL {
  position: fixed;
}

.SendSecureMessagePopup-module__visible___oj9_L {
  opacity: 1;
}

.SendSecureMessagePopup-module__invisible___tE7K9 {
  opacity: 0;
}

.SendSecureMessagePopup-module__col-90___iTprF {
  width: 90% !important;
}

.SendSecureMessagePopup-module__col-auto___d4W2D {
  width: auto !important;
}

.SendSecureMessagePopup-module__medical-tabs___FPlPO {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SendSecureMessagePopup-module__medical-table-new____ZsYq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq::-webkit-scrollbar-track {
  display: none;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq.SendSecureMessagePopup-module__no-pagination___Ppqwi {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq.SendSecureMessagePopup-module__no-pagination___Ppqwi:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq.SendSecureMessagePopup-module__no-pagination___Ppqwi::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendSecureMessagePopup-module__medical-table-new____ZsYq.SendSecureMessagePopup-module__no-pagination___Ppqwi::-webkit-scrollbar-track {
  display: none;
}

.SendSecureMessagePopup-module__medical-table-empty___DZMui {
  padding: 14px 40px !important;
}

.SendSecureMessagePopup-module__icon-btn___pSRAw {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SendSecureMessagePopup-module__search-icon___xttur {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SendSecureMessagePopup-module__disable-select___GOcnH {
  user-select: none;
}

.SendSecureMessagePopup-module__break-word___DMuf5 {
  word-break: break-word;
}

.SendSecureMessagePopup-module__popup-clear-btn___djXWz {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SendSecureMessagePopup-module__scroll-m-b-20___EZFjH {
  scroll-margin-bottom: 20px;
}

.SendSecureMessagePopup-module__content___W563O {
  gap: 16px;
  display: flex;
  padding: 25px 30px;
  flex-direction: column;
}

.SendSecureMessagePopup-module__recipients___lmerT {
  gap: 8px;
  display: flex;
  flex-direction: column;
}

.SendSecureMessagePopup-module__label___Z90YC {
  margin: 0;
  color: #637768;
}

.SendSecureMessagePopup-module__requiredStar___Ab_dF {
  color: #db2828;
}

.SendSecureMessagePopup-module__error___ad_dG {
  margin: 0;
  color: #f01f51;
  min-height: 16px;
}

.SendSecureMessagePopup-module__buttonsContainer___CRfyf {
  gap: 16px;
  display: flex;
  padding: 30px;
  justify-content: end;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/SendSecureMessagePopup/SendSecureMessagePopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AA8pBF;;AA3pBA;EACE,QAAA;EACA,aAAA;EACA,sBAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.content {\n  gap: 16px;\n  display: flex;\n  padding: 25px 30px;\n  flex-direction: column;\n}\n\n.recipients {\n  gap: 8px;\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  margin: 0;\n  color: get-color(greenNew, medium-dark);\n}\n\n.requiredStar {\n  color: get-color(redNew, medium);\n}\n\n.error {\n  margin: 0;\n  color: #f01f51;\n  min-height: 16px;\n}\n\n.buttonsContainer {\n  gap: 16px;\n  display: flex;\n  padding: 30px;\n  justify-content: end;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SendSecureMessagePopup-module__font-s-10____L4Kv`,
	"fontS12": `SendSecureMessagePopup-module__font-s-12___QYcKy`,
	"fontS13": `SendSecureMessagePopup-module__font-s-13___do0SQ`,
	"fontS14": `SendSecureMessagePopup-module__font-s-14___w4prp`,
	"fontS15": `SendSecureMessagePopup-module__font-s-15___kK5kU`,
	"fontS16": `SendSecureMessagePopup-module__font-s-16___dJW4_`,
	"fontS18": `SendSecureMessagePopup-module__font-s-18___toJZx`,
	"fontS20": `SendSecureMessagePopup-module__font-s-20___xxuBC`,
	"fontS22": `SendSecureMessagePopup-module__font-s-22___B8hzP`,
	"fontS28": `SendSecureMessagePopup-module__font-s-28___FDuOt`,
	"fontW400": `SendSecureMessagePopup-module__font-w-400___sU8cG`,
	"fontW500": `SendSecureMessagePopup-module__font-w-500___QxemI`,
	"fontW600": `SendSecureMessagePopup-module__font-w-600___LGX5l`,
	"fontW700": `SendSecureMessagePopup-module__font-w-700___YqZsM`,
	"p5": `SendSecureMessagePopup-module__p-5___XdIN5`,
	"p12": `SendSecureMessagePopup-module__p-12___r9SX_`,
	"p16": `SendSecureMessagePopup-module__p-16___TnPF0`,
	"p30": `SendSecureMessagePopup-module__p-30___i2mbb`,
	"pB0": `SendSecureMessagePopup-module__p-b-0___mPkMR`,
	"pB5": `SendSecureMessagePopup-module__p-b-5___rk2Cd`,
	"pB10": `SendSecureMessagePopup-module__p-b-10___Umrvp`,
	"pB12": `SendSecureMessagePopup-module__p-b-12___HNQ4_`,
	"pB16": `SendSecureMessagePopup-module__p-b-16___YnEcT`,
	"pB18": `SendSecureMessagePopup-module__p-b-18___TgV4c`,
	"pB20": `SendSecureMessagePopup-module__p-b-20___pyxV9`,
	"pB25": `SendSecureMessagePopup-module__p-b-25___Q3Yfc`,
	"pB30": `SendSecureMessagePopup-module__p-b-30___PQX7F`,
	"pB50": `SendSecureMessagePopup-module__p-b-50___dnNNc`,
	"pT0": `SendSecureMessagePopup-module__p-t-0___oyfh1`,
	"pT12": `SendSecureMessagePopup-module__p-t-12___tcOkr`,
	"pT16": `SendSecureMessagePopup-module__p-t-16___pjFbY`,
	"pT18": `SendSecureMessagePopup-module__p-t-18___JwPML`,
	"pT20": `SendSecureMessagePopup-module__p-t-20___yIDd0`,
	"pT30": `SendSecureMessagePopup-module__p-t-30___WH6q4`,
	"pT40": `SendSecureMessagePopup-module__p-t-40___zKEWu`,
	"pT50": `SendSecureMessagePopup-module__p-t-50___KHGUC`,
	"pL20": `SendSecureMessagePopup-module__p-l-20___kEbh5`,
	"pL30": `SendSecureMessagePopup-module__p-l-30___o2TMj`,
	"pL40": `SendSecureMessagePopup-module__p-l-40___lo5SA`,
	"pR16": `SendSecureMessagePopup-module__p-r-16___r9g22`,
	"pR20": `SendSecureMessagePopup-module__p-r-20___uXHiM`,
	"pR30": `SendSecureMessagePopup-module__p-r-30___RcHX8`,
	"pR50": `SendSecureMessagePopup-module__p-r-50___fqnN2`,
	"pR60": `SendSecureMessagePopup-module__p-r-60___JOlve`,
	"mB1": `SendSecureMessagePopup-module__m-b-1___uWY7Z`,
	"mB2": `SendSecureMessagePopup-module__m-b-2___gh9QS`,
	"mB6": `SendSecureMessagePopup-module__m-b-6___oGQW9`,
	"mB8": `SendSecureMessagePopup-module__m-b-8___BvuOk`,
	"mB10": `SendSecureMessagePopup-module__m-b-10___RBdKc`,
	"mB14": `SendSecureMessagePopup-module__m-b-14___o0jWa`,
	"mB16": `SendSecureMessagePopup-module__m-b-16___D8vPP`,
	"mB20": `SendSecureMessagePopup-module__m-b-20___zNQa8`,
	"mB22": `SendSecureMessagePopup-module__m-b-22___gzwnb`,
	"mB24": `SendSecureMessagePopup-module__m-b-24___cqBWw`,
	"mB30": `SendSecureMessagePopup-module__m-b-30___T2lT_`,
	"mB32": `SendSecureMessagePopup-module__m-b-32___rv_o5`,
	"mB40": `SendSecureMessagePopup-module__m-b-40___HI0Kh`,
	"mT2": `SendSecureMessagePopup-module__m-t-2___Dxy7M`,
	"mT3": `SendSecureMessagePopup-module__m-t-3___UGR38`,
	"mT4": `SendSecureMessagePopup-module__m-t-4___y_Jzk`,
	"mT5": `SendSecureMessagePopup-module__m-t-5___nJGCw`,
	"mT8": `SendSecureMessagePopup-module__m-t-8___TdShV`,
	"mT10": `SendSecureMessagePopup-module__m-t-10___MJJHr`,
	"mT15": `SendSecureMessagePopup-module__m-t-15___UbQwK`,
	"mT16": `SendSecureMessagePopup-module__m-t-16___pmzBd`,
	"mT20": `SendSecureMessagePopup-module__m-t-20___zTEBC`,
	"mT22": `SendSecureMessagePopup-module__m-t-22___NLZMi`,
	"mT30": `SendSecureMessagePopup-module__m-t-30___XQsW_`,
	"mT32": `SendSecureMessagePopup-module__m-t-32___Lu9LS`,
	"mLAuto": `SendSecureMessagePopup-module__m-l-auto___b2rYv`,
	"mL4": `SendSecureMessagePopup-module__m-l-4___KDKgv`,
	"mL5": `SendSecureMessagePopup-module__m-l-5___jAD3k`,
	"mL6": `SendSecureMessagePopup-module__m-l-6___v0z0W`,
	"mL8": `SendSecureMessagePopup-module__m-l-8___cW_DP`,
	"mL10": `SendSecureMessagePopup-module__m-l-10___vfSob`,
	"mL16": `SendSecureMessagePopup-module__m-l-16___Ud5wA`,
	"mL20": `SendSecureMessagePopup-module__m-l-20___xeQ8B`,
	"mL24": `SendSecureMessagePopup-module__m-l-24___pqlZQ`,
	"mL30": `SendSecureMessagePopup-module__m-l-30___b7Z7h`,
	"mL35": `SendSecureMessagePopup-module__m-l-35___a2tUw`,
	"mL40": `SendSecureMessagePopup-module__m-l-40___TrZU2`,
	"mR8": `SendSecureMessagePopup-module__m-r-8___PYUeb`,
	"mR10": `SendSecureMessagePopup-module__m-r-10___Ff38Z`,
	"mR16": `SendSecureMessagePopup-module__m-r-16___fF6PU`,
	"mR20": `SendSecureMessagePopup-module__m-r-20___bJ1K9`,
	"mR24": `SendSecureMessagePopup-module__m-r-24___SLh91`,
	"mR30": `SendSecureMessagePopup-module__m-r-30___ZZLf2`,
	"mR40": `SendSecureMessagePopup-module__m-r-40___dy3ZF`,
	"borderR3": `SendSecureMessagePopup-module__border-r-3___nMKfh`,
	"borderR4": `SendSecureMessagePopup-module__border-r-4___JaGAV`,
	"borderR6": `SendSecureMessagePopup-module__border-r-6___yfB8f`,
	"borderR10": `SendSecureMessagePopup-module__border-r-10___GqJLm`,
	"borderR12": `SendSecureMessagePopup-module__border-r-12___UaUfw`,
	"borderR16": `SendSecureMessagePopup-module__border-r-16___uHmfB`,
	"borderR50": `SendSecureMessagePopup-module__border-r-50___SVqUX`,
	"primaryBorder": `SendSecureMessagePopup-module__primary-border___cdTeX`,
	"primaryBorderB": `SendSecureMessagePopup-module__primary-border-b___L9tqo`,
	"primaryBorderT": `SendSecureMessagePopup-module__primary-border-t___wJkNX`,
	"primaryBorderL": `SendSecureMessagePopup-module__primary-border-l___Yx2Nj`,
	"primaryBorderR": `SendSecureMessagePopup-module__primary-border-r___jNoio`,
	"secondaryBorder": `SendSecureMessagePopup-module__secondary-border___JWQU_`,
	"secondaryBorderB": `SendSecureMessagePopup-module__secondary-border-b___ntyM2`,
	"secondaryBorderT": `SendSecureMessagePopup-module__secondary-border-t___wPM77`,
	"secondaryBorderL": `SendSecureMessagePopup-module__secondary-border-l___grW8w`,
	"secondaryBorderR": `SendSecureMessagePopup-module__secondary-border-r___fraiN`,
	"gap0": `SendSecureMessagePopup-module__gap-0___Gp5Jr`,
	"gap2": `SendSecureMessagePopup-module__gap-2____ydAA`,
	"gap4": `SendSecureMessagePopup-module__gap-4___uvuwv`,
	"gap5": `SendSecureMessagePopup-module__gap-5___o3EBy`,
	"gap6": `SendSecureMessagePopup-module__gap-6___Q68dT`,
	"gap8": `SendSecureMessagePopup-module__gap-8___L7wQ9`,
	"gap10": `SendSecureMessagePopup-module__gap-10___MvDSD`,
	"gap12": `SendSecureMessagePopup-module__gap-12___eRmSs`,
	"gap14": `SendSecureMessagePopup-module__gap-14___q5Icb`,
	"gap16": `SendSecureMessagePopup-module__gap-16___xAn0z`,
	"gap18": `SendSecureMessagePopup-module__gap-18___sawpB`,
	"gap20": `SendSecureMessagePopup-module__gap-20___K4gWu`,
	"gap24": `SendSecureMessagePopup-module__gap-24___yoXME`,
	"gap26": `SendSecureMessagePopup-module__gap-26___nS1Oj`,
	"gap30": `SendSecureMessagePopup-module__gap-30___MlbHS`,
	"gap32": `SendSecureMessagePopup-module__gap-32___pIZTc`,
	"gap40": `SendSecureMessagePopup-module__gap-40___jljaF`,
	"gap50": `SendSecureMessagePopup-module__gap-50___dlhrY`,
	"flex1": `SendSecureMessagePopup-module__flex-1___AM4DS`,
	"flexNone": `SendSecureMessagePopup-module__flex-none___DWjSR`,
	"flexColumn": `SendSecureMessagePopup-module__flex-column____weC6`,
	"flexRow": `SendSecureMessagePopup-module__flex-row___NDtIq`,
	"verticallyCentered": `SendSecureMessagePopup-module__vertically-centered___SPLg8`,
	"horizontallyCentered": `SendSecureMessagePopup-module__horizontally-centered___i2DHo`,
	"horizontallyEnd": `SendSecureMessagePopup-module__horizontally-end___aPuFT`,
	"verticallyStart": `SendSecureMessagePopup-module__vertically-start___lyz68`,
	"spaceBetween": `SendSecureMessagePopup-module__space-between___LBpN_`,
	"flexWrap": `SendSecureMessagePopup-module__flex-wrap___UOjvb`,
	"height100": `SendSecureMessagePopup-module__height-100___UxEIU`,
	"width50": `SendSecureMessagePopup-module__width-50___YaYll`,
	"width100": `SendSecureMessagePopup-module__width-100___rJmiH`,
	"cursorPointer": `SendSecureMessagePopup-module__cursor-pointer___LvYpx`,
	"cursorNotAllowed": `SendSecureMessagePopup-module__cursor-not-allowed___ywYPs`,
	"absoluteCentered": `SendSecureMessagePopup-module__absolute-centered___UPGtt`,
	"absolute": `SendSecureMessagePopup-module__absolute___ZYUel`,
	"relative": `SendSecureMessagePopup-module__relative___qODTs`,
	"fixed": `SendSecureMessagePopup-module__fixed___hC6cL`,
	"visible": `SendSecureMessagePopup-module__visible___oj9_L`,
	"invisible": `SendSecureMessagePopup-module__invisible___tE7K9`,
	"col90": `SendSecureMessagePopup-module__col-90___iTprF`,
	"colAuto": `SendSecureMessagePopup-module__col-auto___d4W2D`,
	"medicalTabs": `SendSecureMessagePopup-module__medical-tabs___FPlPO`,
	"medicalTableNew": `SendSecureMessagePopup-module__medical-table-new____ZsYq`,
	"noPagination": `SendSecureMessagePopup-module__no-pagination___Ppqwi`,
	"medicalTableEmpty": `SendSecureMessagePopup-module__medical-table-empty___DZMui`,
	"iconBtn": `SendSecureMessagePopup-module__icon-btn___pSRAw`,
	"searchIcon": `SendSecureMessagePopup-module__search-icon___xttur`,
	"disableSelect": `SendSecureMessagePopup-module__disable-select___GOcnH`,
	"breakWord": `SendSecureMessagePopup-module__break-word___DMuf5`,
	"popupClearBtn": `SendSecureMessagePopup-module__popup-clear-btn___djXWz`,
	"scrollMB20": `SendSecureMessagePopup-module__scroll-m-b-20___EZFjH`,
	"content": `SendSecureMessagePopup-module__content___W563O`,
	"recipients": `SendSecureMessagePopup-module__recipients___lmerT`,
	"label": `SendSecureMessagePopup-module__label___Z90YC`,
	"requiredStar": `SendSecureMessagePopup-module__requiredStar___Ab_dF`,
	"error": `SendSecureMessagePopup-module__error___ad_dG`,
	"buttonsContainer": `SendSecureMessagePopup-module__buttonsContainer___CRfyf`
};
module.exports = ___CSS_LOADER_EXPORT___;
